import apiClient from './api'

export default {
    async get (service) {
        return await apiClient.get(`/cms/settings/${service}`)
    },
    async edit (service, params) {
        return await apiClient.put(`/cms/settings/${service}`, params)
    },
}